import ClickCollectConnector from './clickCollect.props';
import ClickCollectComponent from './clickCollect.component';

export default ClickCollectConnector(ClickCollectComponent);
